import { Injectable } from '@angular/core';
import { AppSession } from '../objects/Session';

@Injectable( {providedIn:'root'} )
export class Globals {
    Session: AppSession;
    CardItems:string[];
    CurrentActiveDetailId:string;
  }